function getVariant() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('variant');
}

function setVariant(variant) {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set('variant', variant);
  const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
  history.replaceState(null, '', newUrl);
}

function addVariantToUrl() {
  if (!getVariant()) {
    const productInfo = document.querySelector('.product__info-wrapper');
    if (!productInfo) return;
    const productForm = document.querySelector('.product-form');
    if (!productForm) return;
    const currentVariant = productForm.querySelector('input[name="id"]').value;
    setVariant(currentVariant);
  }
}

addVariantToUrl();